import { useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import type { Guide, GuideSummary } from '@/api/types';

/** Guides of this host: for students on the marketplace, for professionals on the brand site. */
export function useGuides() {
  return useQuery({
    queryKey: ['guides'],
    queryFn: () => api.get<GuideSummary[]>('/public/guides', { auth: false }),
    staleTime: 10 * 60_000,
  });
}

export function useGuide(slug: string) {
  return useQuery({
    queryKey: ['guides', slug],
    queryFn: () => api.get<Guide>(`/public/guides/${encodeURIComponent(slug)}`, { auth: false }),
    staleTime: 10 * 60_000,
    retry: false,
  });
}
